import { get } from 'lib/sequence/component/state/value'
import { getFirstItem } from 'lib/util'

/**
 * Sets the submitter role filter according to the selected value.
 *
 * @param {Gaia.AppModule.Spec} module the ticket module composition object
 * @returns {function(*, {filter?: {}}=, ...[*]): Promise<[undefined,{filter: {}},...*[]]>}
 */
export default module => async (children, { filter = {} } = {}, ...args) => {
  const { submitterRole } = children

  const accumulatedFilter = filter
  const selectedSubmitterRole = getFirstItem(get(submitterRole))?.key || null
  if (selectedSubmitterRole) {
    selectedSubmitterRole === 'none'
      ? (delete accumulatedFilter.submit_role)
      : (accumulatedFilter.submit_role = selectedSubmitterRole)
  }

  return [children, { filter: accumulatedFilter }, ...args]
}
